/**
 * 页面头部
 */
import '../../css/common/header.less';
import React, { Component } from "react";
import { Link } from 'react-router';
import Cache from 'c-cache';
import lang from '../lang/index';
import SelectLanguage from './language/index';
import UserLogin from './userlogin/index';
import Extra from './extra/index';
import RechargePop from '../mall/recharge-pop';
import gamecenter from '../gamecenter/config';
import Tooltip from 'rc-tooltip';
import qrcode from "../lib/qrcode";
import DownloadView from './download';
import Dl from '../component/download';

class HeaderView extends Component {
	static defaultProps = {
		selected: ''
	}
	constructor(props) {
        super(props);
        
		let navs = [
			{
				text: lang.template('首页'),
				path: '/home',
				type: 'home'
			},
			{
				text: lang.template('娱乐'),
				path: '/allhostlist/hot',
				type: 'hot'
			},
			// {
			// 	text: lang.template('游戏直播'),
			// 	path: '/play',
			// 	type: 'play'
			// },
			{
				text: lang.template('精彩活动'),
				path: '/activity',
				type: 'activity'
			},
			{
				text: lang.template('排行榜'),
				path: '/rank',
				type: 'rank'			
			},
            {
                text: lang.template('游戏中心'),
                path: '/gamecenter',
                type: 'gamecenter'
            },
            {
				text: lang.template('精彩演出'),
				path: '/show',
				type: 'show',
				openInNewTab: false
			},
		];

		let discoverNav = [
			{
				text: lang.template('排行榜'),
				path: '/rank',
				type: 'rank'			
			},
			{
				text: lang.template('小视频'),
				path: '/video',
				type: 'video'
			}];

		let showGameCenter = gamecenter.checkCountryCode(UP.Global.getUserCountryCode());
		
		if (!showGameCenter) {
			discoverNav.splice(-1);
		}

        if (!showGameCenter) {
            navs.splice(-1);
        }

		this.cache = new Cache({
			prefix: 'pcuplive'
		});		
		this.state = {
			selected: this.props.selected,
			navs: navs,
            isLoggedIn: UP.Global.isLogin(),
            showRechargePop: 0,
            downloadPop: false,
            discoverNav: discoverNav,
            isShowDiscoverTip: this.isShowDiscoverTip()
		}
	}

    componentDidMount() {
        Dl.load();
        this.getBarTransform(this.state.selected);
    }

    onMouseOver=()=>{
		this.cache.setCache('showDiscoverTip', 1, 24 * 3600 * 1000);
		this.setState({
			isShowDiscoverTip: false
		});
	}
	isShowDiscoverTip()	{	
		let showDiscoverTip = this.cache.getCache('showDiscoverTip');
		return !showDiscoverTip;
	}

    handleNavItem (type) {
        UP.Global.DA.add({
            eventName: 'clickNavEnter' + type,
            action: 'click',
            label: type
        });
    }

    onClickTab(selected) {
    	this.getBarTransform(selected);
    }

    getBarTransform(selected) {
        let x = 0;
        let tabs = $(this.refs.tabs);
        let bar = $(this.refs.bar);
        let selectedLi = $(this.refs[selected]);
        
        if (tabs.length == 0 || bar.length == 0 || selectedLi.length == 0) {
            return;
        }

        let ulOffset = tabs.offset();
        let lis = $('[data-role="tab"]', tabs);
        let barOffset = $(bar).offset();
        let liOffset = selectedLi.offset();

        x = liOffset.left -  ulOffset.left + (liOffset.width / 2  - barOffset.width / 2);

        bar.css({
            visibility: 'visible',
            msTransform: 'translate3d(' + x + 'px,0,0)',
            WebkitTransform: 'translate3d(' + x + 'px,0,0)',
            transform: 'translate3d(' + x + 'px,0,0)',
        })
    }



	render() {
		let url = window.location.href;
		let downloadPop = this.state.downloadPop;
        
        $discoverDom = (
        	<ul>
        	{
				this.state.discoverNav.map((item, index)=>{
					let selectedCls = item.type == this.state.selected ? 'selected' : '';
                    let cls = `discover-item nav-item-${item.type} ${selectedCls}`;
                    
                    if (UP.Global.version == 'CN' && (item.type == 'video' || item.type == 'gamecenter')) {
                    	// 国内没有小视频和游戏中心
                    	return null;
                    }
                
                    return (
                        <li className={cls} key={index}  ref={item.type}>
                            <h2>
                            	<Link to={item.path}  onClick={this.handleNavItem.bind(this, item.type)}>
	                            	<i></i>
	                                <em>{item.text}</em>
                                </Link>
                            </h2>
                        </li>
                    )
				})
			}
			</ul>
        );
		return (
			<div className="header" id="J-Header" ref="header">
				<div className="top-wrap">
					<div className="top" ref="tops">
					    <Tooltip getTooltipContainer={()=>this.refs.tops} overlay={<DownloadView/>} placement="bottom" trigger={['hover']} overlayClassName="header-popover">
		                    <div className="btn-head download"><i className="icon"></i><em>{lang.template('下载客户端')}</em></div>
		                </Tooltip>
		                <div className={`split ${UP.Global.version == 'CN' ? 'unvisible' : ''}`}></div>
						<SelectLanguage/>
					</div>
				</div>
				<div className="header-wrap">
					<Link to="/home">
						<div className="logo-icon"></div>
					</Link>
					<div className="header-nav">
						<ul className="nav-list clearfix" ref="tabs">
							{
								this.state.navs.map((item, index)=>{

									let selectedCls = item.type == this.state.selected ? 'selected' : '';
				                    let cls = `nav-item nav-item-${item.type} ${selectedCls}`;
				                    
				                    if (UP.Global.version == 'CN' && (item.type == 'video' || item.type == 'gamecenter')) {
				                    	// 国内没有小视频和游戏中心
				                    	return null;
				                    }

				                    if (UP.Global.version !=='CN' && item.type == 'show') {
				                    	return null;
				                    }
				                
				                    return (
				                        <li className={cls} key={index} onClick={this.onClickTab.bind(this, item.type)} ref={item.type}>
				                            <h2>
				                            	<Link to={item.path} onClick={this.handleNavItem.bind(this, item.type)}>
					                            	<i></i>
					                                <em>{item.text}</em>
				                                </Link>
				                            </h2>
				                        </li>
				                    )
								})
							}
							<li className="nav-item nav-item-discover hidden" key="dis" ref="discover" key="descover" onMouseOver={this.onMouseOver}>
								<Tooltip getTooltipContainer={()=>this.refs.discover} overlay={$discoverDom} placement="bottom" trigger={['hover']} overlayClassName="discover-popover">
	                            <h2 className="discover">
	                            	<Link>
	                                <em>{lang.template('发现')}</em>
	                            	<i className={`${this.state.isShowDiscoverTip ? 'discover-tip' : ''}`}></i>
	                                </Link>
	                            </h2>
	                            </Tooltip>
	                        </li>
							<li key="bar" data-role="bar" ref="bar" className="tab-bar"></li>
						</ul>
					</div>
					<div className="header-extra">
						<Extra {...this.props} key={this.props.selected || 'extra'}/>
						
						<UserLogin profile={true}/>
					</div>
				</div>
				
			</div>
		);
	}
}

export default HeaderView;



// WEBPACK FOOTER //
// ./js/header/index.js